import dayjs from 'dayjs';
import customDateFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from 'utils/enums';

dayjs.extend(customDateFormat);

export const convertDateFormat = (date?: string, format?: DATE_FORMAT): dayjs.Dayjs => dayjs(date, format);
